import { Button } from '@/shared/components/ui/button';
import { Film, ListVideo, Sparkles } from 'lucide-react';
import { FeatureEmptyState } from '@/shared/components/custom/FeatureEmptyState';

const StoryboardNoFramesState = ({
    selectedShot,
    selectedShotFrame,
    onToggleShotList,
    onInitiateFrameGeneration,
    onGenerateAll
}: {
    selectedShot: any;
    selectedShotFrame: any;
    onToggleShotList: () => void;
    onInitiateFrameGeneration: (shot: any) => void;
    onGenerateAll: () => void;
}) => {
    return (
        <FeatureEmptyState
            className=" bg-muted/5  h-[60vh] py-20"
            icon={<Film className="h-10 w-10 text-primary" />}
            title={selectedShot ? "No Frame Yet" : "Select a Shot"}
            description={
                selectedShot
                    ? "This shot doesn't have a generated frame yet. Generate it now!"
                    : "To create a storyboard, please select a shot from the list on the right."
            }
        >
            {!selectedShot && (
                <div className="flex gap-4">
                    <Button size="lg" onClick={onGenerateAll} className="">
                        <Sparkles className="mr-2 h-5 w-5" />
                        Generate Frames
                    </Button>
                    <Button variant="outline" size="lg" onClick={onToggleShotList} className="px-8 flex items-center">
                        <ListVideo className="mr-2 h-5 w-5" />
                        Open Shot List
                    </Button>
                </div>
            )}

            {selectedShot && (
                <Button
                    size="lg"
                    onClick={() => onInitiateFrameGeneration(selectedShot)}
                    className=""
                >
                    <Sparkles className="mr-2 h-5 w-5" />
                    Generate Frame
                </Button>
            )}
        </FeatureEmptyState>
    )
}

export default StoryboardNoFramesState
